import type { ThemeTextColor } from '@rover/kibble/styles/themeTypes';
import { IconBlockVariant } from '@rover/types/src/IconBlockVariant';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

export const TITLE_COLOR_FOR_VARIANT: Record<IconBlockVariant, ThemeTextColor> = {
  [IconBlockVariant.DEFAULT]: 'primary',
  [IconBlockVariant.SUCCESS]: 'success',
  [IconBlockVariant.CAUTION]: 'caution',
  [IconBlockVariant.ERROR]: 'error',
};

export const getIconColors = (theme: RoverTheme): Record<IconBlockVariant, string> => ({
  [IconBlockVariant.DEFAULT]: theme.textColor.primary.toString(),
  [IconBlockVariant.SUCCESS]: theme.textColor.success.toString(),
  [IconBlockVariant.CAUTION]: theme.textColor.caution.toString(),
  [IconBlockVariant.ERROR]: theme.textColor.error.toString(),
});
